import React from "react";
import { Paper, Typography, Link, Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { canAccessSiteOperations, useCapabilities } from "../contexts/CapabilitiesContext";

const Footer = () => {
  const { capabilities, capabilitiesLoaded } = useCapabilities();
  const showAdmin = capabilitiesLoaded && Boolean(capabilities?.is_admin);
  const showOperations = capabilitiesLoaded && canAccessSiteOperations(capabilities);
  const adminLinkSx = { fontSize: "0.875rem", py: 0.5, minHeight: 32, display: "inline-flex", alignItems: "center" };
  return (
    <Paper
      component="footer"
      square
      sx={{
        width: "100%",
        maxWidth: "100%",
        mt: "auto",
        px: { xs: 2, sm: 3 },
        py: 2,
        borderRadius: 0,
        borderTop: "1px solid rgba(15,23,42,0.08)",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          width: "100%",
          mx: "auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          © 2026 The Collector Stop. All rights reserved.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Link component={RouterLink} to="/terms" underline="hover">
            Terms of Service
          </Link>
          <Link component={RouterLink} to="/privacy" underline="hover">
            Privacy Policy
          </Link>
          <Link component={RouterLink} to="/contact" underline="hover">
            Contact Us
          </Link>
          {showAdmin && <Link
            component={RouterLink}
            to="/admin/intelligence"
            underline="hover"
            color="text.secondary"
            sx={adminLinkSx}
          >
            Admin
          </Link>}
          {showOperations && <Link
            component={RouterLink}
            to="/admin/mobile"
            underline="hover"
            color="text.secondary"
            sx={adminLinkSx}
          >
            Operations
          </Link>}
        </Box>
      </Box>
    </Paper>
  );
};

export default Footer;
